"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _Icon = require("../Icon");
var _react2 = _interopRequireDefault(require("@tippyjs/react"));
require("tippy.js/dist/tippy.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GenerateTooltip = _ref => {
  let {
    copied
  } = _ref;
  if (copied) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "toast-message-wrapper"
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ["far", "check-circle"],
      size: "lg",
      className: "toast-message-icon",
      color: "#28a745"
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "toast-message-text"
    }, "\xA0 Copied!"));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", null, "Click to copy!");
  }
};
function TextTruncateWrapper(_ref2) {
  let {
    cell
  } = _ref2;
  const [display, setDisplay] = (0, _react.useState)(false);
  const [copied, setCopied] = (0, _react.useState)(false);
  let idReference = (0, _react.useRef)(null);
  const copyToClipboard = text => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      setDisplay(true);
      setCopied(true);
      return navigator.clipboard.writeText(text);
    }
    return Promise.reject("The Clipboard API is not available.");
  };
  (0, _react.useEffect)(() => {
    const makeTrue = () => {
      setDisplay(true);
    };
    const makeFalse = () => {
      setDisplay(false);
      setCopied(false);
    };
    let parentRef = idReference.current.parentElement;
    parentRef.addEventListener("mouseenter", makeTrue);
    parentRef.addEventListener("mouseleave", makeFalse);
    return () => {
      parentRef.removeEventListener("mouseenter", makeTrue);
      parentRef.removeEventListener("mouseleave", makeFalse);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "text-truncate-wrapper",
    ref: idReference
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react2.default, {
    content: cell,
    placement: "bottom",
    delay: [500, 0]
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-truncate"
  }, (0, _lodash.truncate)(cell, {
    length: display ? 7 : 9
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: display ? 'show-Id-copyIcon' : 'hide-Id-copyIcon'
  }, /*#__PURE__*/_react.default.createElement(_react2.default, {
    content: /*#__PURE__*/_react.default.createElement(GenerateTooltip, {
      copied: copied
    }),
    hideOnClick: false,
    delay: [300, 0]
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: ["far", "copy"],
    size: "lg",
    className: "text-copy-icon-button",
    color: "#6c757d",
    onClick: () => copyToClipboard(cell)
  }))))));
}
var _default = exports.default = TextTruncateWrapper;